/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamqueues1Inputs */

const en_entity_teamqueues1 = /** @type {(inputs: Entity_Teamqueues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Queues`)
};

const de_entity_teamqueues1 = /** @type {(inputs: Entity_Teamqueues1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queues`)
};

/**
* | output |
* | --- |
* | "Team Queues" |
*
* @param {Entity_Teamqueues1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamqueues1 = /** @type {((inputs?: Entity_Teamqueues1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamqueues1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamqueues1(inputs)
	return de_entity_teamqueues1(inputs)
});
export { entity_teamqueues1 as "entity_teamQueues" }